import React from 'react';
import Tabs from '../../common/Jetlift/tabs';
import TubingSection from './tubing';
import Well from './well';
import Fluid from './fluid';
import Others from './others';
import JetPump from './jet-pump';
import { FormProvider } from 'react-hook-form';

interface InputSectionProps {
    children?: React.ReactNode;
    methods?: any;
}

const InputSection: React.FC<InputSectionProps> = ({ children, methods }) => {
    const [activeTab, setActiveTab] = React.useState(0);

    const handleTabChange = (index: number) => {
        setActiveTab(index);
    };

    const tabs = [
        {
            label: 'Tubing', content: (
                <TubingSection />
            )
        },
        {
            label: 'Well', content: (
                <Well />
            )
        },
        {
            label: 'Fluid', content: (
                <Fluid />
            )
        },
        {
            label: 'Jet pump', content: (
                <JetPump />
            )
        },
        {
            label: 'Others', content: (
                <Others />
            )
        },
    ];

    return (
        <FormProvider {...methods}>
            <div className="flex items-start flex-col justify-between flex-1 rounded-[8px] border-darkcolor-400 bg-darkcolor-700 border-[1px] text-neutral-25 w-full overflow-x-hidden" role="input-section-container">
                {children}
                <Tabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} className='bg-darkcolor-700' />
            </div>
        </FormProvider>
    );
};

export default InputSection;